/* ==========================================================================
   Coverage Table
   Progressive enhancement for sections/coverage-table.liquid.
   The grid renders fully without JS. This only injects the matrix magnitude
   bars: it reads each value cell's data-covt-val, finds the largest numeric
   value in the section, and appends a proportional bar. Non-numeric values
   (e.g. "Custom") get no bar. Bars are opt-in via data-covt-bars="true".
   ========================================================================== */
(function () {
  'use strict';

  function toNumber(raw) {
    if (!raw) return NaN;
    var cleaned = String(raw).replace(/[^0-9.]/g, '');
    if (cleaned === '') return NaN;
    return parseFloat(cleaned);
  }

  class CoverageTable extends HTMLElement {
    connectedCallback() {
      if (this.getAttribute('data-covt-bars') !== 'true') return;
      this._injectBars();
    }

    _injectBars() {
      var cells = Array.prototype.slice.call(this.querySelectorAll('[data-covt-val]'));
      if (!cells.length) return;

      var max = 0;
      cells.forEach(function (cell) {
        var n = toNumber(cell.getAttribute('data-covt-val'));
        if (!isNaN(n) && n > max) max = n;
      });
      if (max <= 0) return;

      cells.forEach(function (cell) {
        if (cell.querySelector('.covt-bar')) return; // idempotent (re-render in editor)
        var n = toNumber(cell.getAttribute('data-covt-val'));
        if (isNaN(n) || n <= 0) return;
        var pct = Math.max(4, Math.round((n / max) * 100));
        var bar = document.createElement('div');
        bar.className = 'covt-bar';
        var fill = document.createElement('i');
        fill.style.width = pct + '%';
        bar.appendChild(fill);
        cell.appendChild(bar);
      });
    }
  }

  if (!customElements.get('coverage-table')) {
    customElements.define('coverage-table', CoverageTable);
  }
})();
